// extracted by mini-css-extract-plugin
export var activeIndex = "VideoEmbed-module--activeIndex--e8829";
export var cMarginTop = "VideoEmbed-module--c-margin-top--01640";
export var cPadding = "VideoEmbed-module--c-padding--0cb0d";
export var cPaddingBottom = "VideoEmbed-module--c-padding-bottom--ac269";
export var cPaddingTop = "VideoEmbed-module--c-padding-top--851b8";
export var content = "VideoEmbed-module--content--a2865";
export var date = "VideoEmbed-module--date--f4e91";
export var disabled = "VideoEmbed-module--disabled--6df9d";
export var ellipsis = "VideoEmbed-module--ellipsis--c99e7";
export var featuredSection = "VideoEmbed-module--featuredSection--aded5";
export var globalSpacing = "VideoEmbed-module--global-spacing--2c922";
export var globalSpacingBottom = "VideoEmbed-module--global-spacing-bottom--129d8";
export var globalSpacingTop = "VideoEmbed-module--global-spacing-top--bb2d3";
export var image = "VideoEmbed-module--image--b3223";
export var imageWrapper = "VideoEmbed-module--imageWrapper--488e3";
export var index = "VideoEmbed-module--index--58775";
export var inner = "VideoEmbed-module--inner--db0d3";
export var listItem = "VideoEmbed-module--listItem--c36cd";
export var maxWidth = "VideoEmbed-module--max-width--693a1";
export var navButton = "VideoEmbed-module--navButton--dad1a";
export var pagination = "VideoEmbed-module--pagination--55cfd";
export var para = "VideoEmbed-module--para--83654";
export var styleTick = "VideoEmbed-module--styleTick--32681";
export var tag = "VideoEmbed-module--tag--6f8db";
export var tagWrapper = "VideoEmbed-module--tagWrapper--97673";
export var title = "VideoEmbed-module--title--4b299";